import { useGetAddress, useVaultAddress } from '../useStorage'

import TokenggAVAX from '@/contracts/TokenggAVAX'
import xGGP from '@/contracts/xGGP'
import { Interface } from 'ethers'

const useTokenggAVAXContract = () => {
  const { data } = useGetAddress('TokenggAVAX')

  const contractInterface = new Interface(TokenggAVAX)

  return {
    address: data,
    contractInterface,
    abi: TokenggAVAX,
  }
}

export const useTokenxGGPContract = () => {
  const data = useVaultAddress()

  const contractInterface = new Interface(xGGP)
  return {
    address: data,
    contractInterface,
    abi: xGGP,
  }
}

export default useTokenggAVAXContract
